// hooks/useFeatureRelease.ts
import { useEffect, useState } from "react";
import { getFeatureReleaseStatus } from "../services/public.service";

interface FeatureReleaseResponse {
	status: boolean;
	data: {
		key: string;
		domain: string;
		enabled: boolean;
	};
}

interface FeatureReleaseResult {
	enabled: boolean;
	loading: boolean;
}

export const useFeatureRelease = (featureKey: string): FeatureReleaseResult => {
	const [enabled, setEnabled] = useState(false);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let isMounted = true;
		setLoading(true);

		getFeatureReleaseStatus<FeatureReleaseResponse>(featureKey)
			.then((res) => {
				if (isMounted) setEnabled(Boolean(res?.data?.enabled));
			})
			.catch(() => {
				if (isMounted) setEnabled(false);
			})
			.finally(() => {
				if (isMounted) setLoading(false);
			});

		return () => {
			isMounted = false;
		};
	}, [featureKey]);

	return { enabled, loading };
};
